import { createBrowserRouter, Navigate } from "react-router-dom";
import { Landing } from "./pages/Landing";
import { SignIn } from "./pages/SignIn";
import { SignUp } from "./pages/SignUp";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ForgotPasswordConfirm } from "./pages/ForgotPasswordConfirm";
import { AppLayout } from "./pages/AppLayout";
import { EvidenceList } from "./pages/EvidenceList";
import { Upload } from "./pages/Upload";
import { EvidenceDetail } from "./pages/EvidenceDetail";
import { Verify } from "./pages/Verify";
import { RequireAuth } from "./components/RequireAuth";

export const router = createBrowserRouter([
  { path: "/", element: <Landing /> },
  { path: "/signin", element: <SignIn /> },
  { path: "/signup", element: <SignUp /> },
  { path: "/forgot", element: <ForgotPassword /> },
  { path: "/forgot/confirm", element: <ForgotPasswordConfirm /> },
  { path: "/verify/:evidenceId", element: <Verify /> },
  {
    path: "/app",
    element: <RequireAuth><AppLayout /></RequireAuth>,
    children: [
      { index: true, element: <EvidenceList /> },
      { path: "upload", element: <Upload /> },
      { path: "evidence/:evidenceId", element: <EvidenceDetail /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
